import {Component, OnInit} from '@angular/core';
import {AuthService} from "../services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatDialogModule} from "@angular/material/dialog";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule
    ]
})
export class DashboardComponent implements OnInit {

  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.authService.user$.subscribe(user => {
      //this.operators$ = this.operatorsService.getOperators();
    });
  }
}
